import React from 'react'

function TenderTextVentilation() {
  return (
    <embed src="\pdfs\DAT2.4.2_DK-LIG_Aktiver_Deckenkuehlkonvektor_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextVentilation